// 对http请求进行封装
import axios from 'axios'
import RequestError from './RequestError'
import logger from 'loglevel'

/*
 * $Id:$
 * Copyright 2019 Emily36107@outlook.com All rights reserved.
 */

let vm = null
let $store = null

function $t (key) {
  return (vm && vm.$i18n && vm.$t) ? vm.$t.apply(vm, arguments) : key
}
// 使用自定义的配置文件发送请求
const instance = axios.create({
  baseURL: '',
  timeout: 3000
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  const fetchError = $t('error.fetchError')
  if (!response.data) {
    if (logger.getLevel() <= logger.levels.INFO) {
      logger.info(response.data)
    }
    return Promise.reject(new Error(fetchError))
  }
  if (response.data.success) {
    if (logger.getLevel() <= logger.levels.DEBUG) {
      logger.debug(response.data)
    }
    return response.data
  } else {
    let msg
    switch (response.data.code) {
      case 100101:
      case 100102:
      case 100103:
      case 100104:
      case 100106:
      case 100107:
      case 100112:
      case 100113:
      case 100105:
      case 100108:
      case 100109:
      case 100110:
      case 100111:
        $store.dispatch('LOGOUT')
        msg = $t(`error.authentication.${response.data.code}`)
        break
      case 100115:
        // don't logout on unauthorized request.
        msg = $t(`error.authentication.${response.data.code}`)
        break
      case 100116:
        msg = response.data.msg.replace('[invalid authorize for software]', '')
        $store.dispatch('LOGOUT', msg)
        break
      default:
        msg = response.data.msg || fetchError
        msg = msg.replace('[invalid authorize for software]', '')
        break
    }
    if (logger.getLevel() <= logger.levels.INFO) {
      logger.info(response.data)
    }
    return Promise.reject(new RequestError(msg, response.data.code))
  }
  // 对响应数据做点什么
  // eslint-disable-next-line no-unreachable
  if (response.status === 200) {
    return response.data
  } else {
    console.error('请求错误')
    console.error(response)
  }
  return response
}, function (error) {
  const unkownError = $t('error.unkownError')
  const fetchError = $t('error.fetchError')
  if (logger.getLevel() <= logger.levels.WARN) {
    logger.warn(error)
  }
  let err = new Error(!(error instanceof Error || ('config' in error)) ? unkownError : fetchError)
  return Promise.reject(err)
})
// 默认导出  只能有一个默认导出，可以自己起名字，导入时可以不加{}
export default instance



// WEBPACK FOOTER //
// ./src/api/http.js